import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Card, Row, Col, Alert, Toast } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { addManager, updateManager } from '../../services/managerService';

const ManagerForm = ({ editingManager, onSubmit, onCancel, isModal = false }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    positionName: '',
    phone: '',
    fax: '',
    email: '',
    dutyAndResponsibility: '',
    mission: '',
    vision: '',
    picture: null,
    sequenceNr: 0
  });

  // Düzenleme modunda form verilerini doldur
  useEffect(() => {
    if (editingManager) {
      setFormData({
        name: editingManager.name || '',
        positionName: editingManager.positionName || '',
        phone: editingManager.phone || '',
        fax: editingManager.fax || '',
        email: editingManager.email || '',
        dutyAndResponsibility: editingManager.dutyAndResponsibility || '',
        mission: editingManager.mission || '',
        vision: editingManager.vision || '',
        picture: null, // Yeni resim seçilmediği sürece null
        sequenceNr: editingManager.sequenceNr || 0
      });
    }
  }, [editingManager]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        setError('Lütfen geçerli bir resim dosyası seçin');
        e.target.value = '';
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        setError('Resim dosyası 5MB\'dan büyük olamaz');
        e.target.value = '';
        return;
      }

      setFormData(prevState => ({
        ...prevState,
        picture: file
      }));
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log('Form data being sent:', {
        ...formData,
        picture: formData.picture ? `${formData.picture.name} (${formData.picture.size} bytes)` : null
      });

      let response;
      if (editingManager) {
        // Güncelleme
        response = await updateManager(editingManager.guid, formData);
        console.log('Manager update response:', response);
      } else {
        // Ekleme
        response = await addManager(formData);
        console.log('Manager add response:', response);
      }

      // Başarılı işlem bildirimi göster
      setShowToast(true);
      
      if (isModal && onSubmit) {
        // Modal içinde çalışıyorsa parent'a bildir
        onSubmit(editingManager ? { ...editingManager, ...formData } : response.data);
      } else {
        // Normal sayfa ise yönlendir
        setTimeout(() => {
          navigate('/managers');
        }, 1500);
      }
    } catch (error) {
      console.error('Form submission error:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      setError(error.response?.data?.message || `Müdür ${editingManager ? 'güncellenirken' : 'eklenirken'} bir hata oluştu.`);
    } finally {
      setLoading(false);
    }
  };

  const formContent = (
    <>
      {!isModal && (
        <div
          style={{
            position: 'fixed',
            top: 20,
            right: 20,
            zIndex: 9999
          }}
        >
          <Toast
            show={showToast}
            onClose={() => setShowToast(false)}
            delay={1500}
            autohide
            bg="success"
          >
          <Toast.Body className="text-white">
            Müdür {editingManager ? 'başarıyla güncellendi!' : 'başarıyla eklendi!'}
          </Toast.Body>
          </Toast>
        </div>
      )}

      {!isModal && (
        <Card className="mt-4 mb-4">
          <Card.Body>
            <h2 className="mb-4">{editingManager ? 'Müdür Düzenle' : 'Yeni Müdür Ekle'}</h2>
          </Card.Body>
        </Card>
      )}
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Ad Soyad *</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Pozisyon</Form.Label>
                  <Form.Control
                    type="text"
                    name="positionName"
                    value={formData.positionName}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Telefon</Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Fax</Form.Label>
                  <Form.Control
                    type="text"
                    name="fax"
                    value={formData.fax}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>E-posta</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Görev ve Sorumluluklar</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="dutyAndResponsibility"
                    value={formData.dutyAndResponsibility}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Misyon</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="mission"
                    value={formData.mission}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Vizyon</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="vision"
                    value={formData.vision}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Fotoğraf *</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    required={!editingManager}
                  />
                  {editingManager && (
                    <Form.Text className="text-muted">
                      Mevcut fotoğrafı değiştirmek için yeni bir fotoğraf seçin
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>

            {error && (
              <Alert variant="danger" className="mt-3">
                {error}
              </Alert>
            )}

            <div className="d-flex justify-content-end gap-2 mt-3">
              <Button 
                variant="secondary" 
                onClick={isModal ? onCancel : () => navigate('/managers')}
                disabled={loading}
              >
                İptal
              </Button>
              <Button 
                variant="primary" 
                type="submit"
                disabled={loading}
              >
                {loading ? (editingManager ? 'Güncelleniyor...' : 'Kaydediliyor...') : (editingManager ? 'Güncelle' : 'Kaydet')}
              </Button>
            </div>
          </Form>
    </>
  );

  return isModal ? formContent : <Container>{formContent}</Container>;
};

export default ManagerForm;
